import apiClient, { extractData } from "./client";

export async function getInvestigations() {
  const response = await apiClient.get("/investigations");
  return extractData(response);
}

export async function getInvestigation(id) {
  const response = await apiClient.get(`/investigations/${id}`);
  return extractData(response);
}

export async function requestInvestigation(data) {
  const response = await apiClient.post("/investigations/requests", data);
  return extractData(response);
}

export async function openInvestigation(data) {
  const response = await apiClient.post("/investigations", data);
  return extractData(response);
}

export async function scheduleInvestigation(id, data) {
  const response = await apiClient.post(`/investigations/${id}/schedule`, data);
  return extractData(response);
}

export async function updateInvestigation(id, data) {
  const response = await apiClient.patch(`/investigations/${id}`, data);
  return extractData(response);
}

export async function submitInvestigationDecision(id, data) {
  const response = await apiClient.post(`/investigations/${id}/decision`, data);
  return extractData(response);
}

export async function reviewInvestigation(id, data) {
  const response = await apiClient.post(`/investigations/${id}/review`, data);
  return extractData(response);
}

export async function rejectInvestigationRequest(id, data = {}) {
  const response = await apiClient.post(`/investigations/${id}/reject`, data);
  return extractData(response);
}
